import React, { useEffect, useState } from "react";
import api from "../../services/api";
import { useNavigate } from "react-router-dom";

import PageHeader from "../components/PageHeader";
import SearchBar from "../components/SearchBar";
import DataTable from "../components/DataTable";
import Loader from "../components/Loader";
import ConfirmModal from "../components/ConfirmModal";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import API_URL from "../../config";

const Candidates = () => {

    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);

    const [candidates, setCandidates] = useState([]);

    const [filteredCandidates, setFilteredCandidates] = useState([]);

    const [search, setSearch] = useState("");

    const [selectedCandidate, setSelectedCandidate] = useState(null);

    const [deleteId, setDeleteId] = useState(null);

    useEffect(() => {

        fetchCandidates();

    }, []);

    useEffect(() => {

        filterCandidates();

    }, [search, candidates]);

    const fetchCandidates = async () => {

        try {

            setLoading(true);

            const response = await api.get("/admin/candidates");

            setCandidates(response.data.data || []);
            setFilteredCandidates(response.data.data || []);
        } catch (error) {

            console.error("Error fetching candidates", error);

        } finally {

            setLoading(false);

        }

    };

    const filterCandidates = () => {

        if (!search.trim()) {

            setFilteredCandidates(candidates);

            return;

        }

        const keyword = search.toLowerCase();

        const filtered = candidates.filter((candidate) =>

            candidate.name?.toLowerCase().includes(keyword) ||

            candidate.email?.toLowerCase().includes(keyword) ||

            candidate.phone?.includes(search)

        );

        setFilteredCandidates(filtered);

    };
    const downloadPDF = () => {
    const doc = new jsPDF();

    doc.setFontSize(18);
    doc.text("Candidates List", 14, 20);

    autoTable(doc, {
        head: [[
            "ID",
            "Name",
            "Email",
            "Phone",
            "Qualification",
            "Experience",
            "Location"
        ]],
        body: filteredCandidates.map(candidate => [
            candidate.id,
            candidate.name,
            candidate.email,
            candidate.phone,
            candidate.qualification,
            candidate.experience_years,
            candidate.location
        ])
    });

    doc.save("Candidates_List.pdf");
};
const exportExcel = () => {

    const data = filteredCandidates.map(candidate => ({
        ID: candidate.id,
        Name: candidate.name,
        Email: candidate.email,
        Phone: candidate.phone,
        Qualification: candidate.qualification,
        Experience: candidate.experience_years,
        Location: candidate.location
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Candidates");

    const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array"
    });

    const blob = new Blob(
        [excelBuffer],
        {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    );

    saveAs(blob, "Candidates_List.xlsx");
};

    const handleDelete = async () => {

        if (!deleteId) return;

        try {

            await api.delete(

                `${API_URL}/admin/candidates/${deleteId}`

            );

            fetchCandidates();

        } catch (error) {

            console.error("Delete failed", error);

        }

    };

    const columns = [

        {
            key: "id",
            label: "ID"
        },

        {
            key: "name",
            label: "Name"
        },

        {
            key: "email",
            label: "Email"
        },

        {
            key: "phone",
            label: "Phone"
        },
        {
    key: "experience_years",
    label: "Experience"
},
{
    key: "location",
    label: "Location"
}

    ];
        if (loading) {

        return (
            <Loader
                fullScreen={true}
                text="Loading Candidates..."
            />
        );

    }

    return (

        <div className="space-y-6">

            <PageHeader
                title="Candidates"
                subtitle="Manage all registered candidates"
                showButton={false}
                breadcrumb={[
                    {
                        label: "Dashboard",
                        link: "/admin"
                    },
                    {
                        label: "Candidates"
                    }
                ]}
            />

            <div className="bg-white rounded-3xl shadow-lg p-6">

    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">

        <SearchBar
            value={search}
            onChange={setSearch}
            onClear={() => setSearch("")}
            placeholder="Search candidates..."
        />

    </div>

    <DataTable
        title="Candidate List"
        columns={columns}
        data={filteredCandidates}
        emptyMessage="No candidates found."
        actions={(candidate) => (
            <div className="flex justify-center gap-2">

                {/* View */}

                <button
                    onClick={() => setSelectedCandidate(candidate)}
                    className="px-3 py-2 rounded-xl bg-blue-100 text-blue-600 hover:bg-blue-200 transition"
                >
                    View
                </button>

                {/* Edit */}

                <button
                    onClick={() =>
                        navigate(`/admin/candidates/edit/${candidate.id}`)
                    }
                    className="px-3 py-2 rounded-xl bg-yellow-100 text-yellow-700 hover:bg-yellow-200 transition"
                >
                    Edit
                </button>

                {/* Delete */}

                <button
                    onClick={() => setDeleteId(candidate.id)}
                    className="px-3 py-2 rounded-xl bg-red-100 text-red-600 hover:bg-red-200 transition"
                >
                    Delete
                </button>

            </div>
        )}
    />
    <div className="flex gap-3 mb-4">

    <button
        onClick={downloadPDF}
        className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
    >
        Download PDF
    </button>

    <button
        onClick={exportExcel}
        className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
    >
        Export Excel
    </button>

</div>

</div>

           <ConfirmModal
    open={deleteId !== null}
    title="Delete Candidate"
    message="Are you sure you want to delete this candidate? This action cannot be undone."
    confirmText="Delete"
    onConfirm={() => {
        handleDelete();
        setDeleteId(null);
    }}
    onCancel={() => setDeleteId(null)}
/>
                {selectedCandidate && (

                <div
                    className="modal fade show"
                    style={{
                        display: "block",
                        backgroundColor: "rgba(0,0,0,0.5)"
                    }}
                >

                    {selectedCandidate && (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">

        <div className="bg-white rounded-3xl shadow-2xl w-full max-w-3xl p-8">

            <div className="flex justify-between items-center mb-6">

                <h2 className="text-2xl font-bold">
                    Candidate Details
                </h2>

                <button
                    onClick={() => setSelectedCandidate(null)}
                    className="text-gray-500 hover:text-red-500 text-2xl"
                >
                    ✕
                </button>

            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                <Detail label="Name" value={selectedCandidate.name} />
                <Detail label="Email" value={selectedCandidate.email} />
                <Detail label="Phone" value={selectedCandidate.phone} />
                <Detail label="Qualification" value={selectedCandidate.qualification} />
                <Detail label="Experience" value={selectedCandidate.experience_years} />
                <Detail label="Location" value={selectedCandidate.location} />

            </div>

            <div className="flex justify-end mt-8">

                <button
                    onClick={() => setSelectedCandidate(null)}
                    className="px-5 py-2 rounded-xl bg-gray-200 hover:bg-gray-300"
                >
                    Close
                </button>

            </div>

        </div>

    </div>
)}

                </div>

            )}

        </div>

    );

};
const Detail = ({ label, value }) => (
    <div>
        <p className="text-sm text-gray-500">{label}</p>
        <p className="font-semibold text-gray-800">
            {value || "-"}
        </p>
    </div>
);

export default Candidates;